import React, {Component, Fragment} from 'react';
import {roomMessagesByRoomId} from "../../../../selectors/roomMessage-selector";
import {bindActionCreators} from "redux";
import {
    fetchRoomMessages,
    resetRoomMessages,
    subscribeRoomMessage,
    unsubscribeRoomMessage
} from "../../../../creators/room.messages";
import {deleteRoomMessage} from "../../../../creators/room.message";
import {connect} from "react-redux";
import {SpinLoader} from "../../../components/Loader";
import {Button} from "../../../components/Button";
import moment from "moment";
import RoomMessage from "./RoomMessage";
//import SendMessage from "./SendMessage";
import _ from "lodash";
import Alert from "../../../components/Alert";
import Modal from "../../../components/Modal";
import RoomSendMessage from "./RoomSendMessage/RoomSendMessage";

const hydrates = (messages) => {
    let userId = 0;
    let messagesTime = 0;
    return [...messages]
        .reverse()
        .map((item, index) => {
            item.isSameUser = true;
            item.shortPeriod = false;
            if (item.isMessage !== false) {
                if (item.owner && userId !== item.owner._id) {
                    item.isSameUser = false;
                    if (messages[index - 1]) {
                        messages[index - 1].isSameUser = true;
                    }
                } else {
                    item.isSameUser = true;
                    if (messages[index - 1]) {
                        messages[index - 1].isSameUser = true;
                    }
                    if (moment(item.createdAt).diff(messagesTime, 'minutes') <= 5) {
                        item.shortPeriod = true;
                        if (messages[index - 1]) {
                            messages[index - 1].shortPeriod = true;
                        }
                    } else {
                        if (messages[index - 1]) {
                            messages[index - 1].shortPeriod = false;
                        }
                    }
                }
                messagesTime = item.createdAt;
                userId = _.get(item,"owner._id");
            }
            return item;
        });
}

class RoomChat extends Component {
    constructor(props) {
        super(props);

        this.filter = {
            page: 1,
            limit: 20,
            sort: "-createdAt"
        };
        this.state = {
            toggleDeleteAlert: false,
            deleteMessageId: null,
            isToogleUpload : false
        }
        this.messageListRef = React.createRef();

    }

    componentDidMount() {
        this._fetchMessages();
        this.props.subscribeRoomMessage(this.props.room._id);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.room._id !== prevProps.room._id) {
            this.props.unsubscribeRoomMessage();
            this.props.resetRoomMessages();
            this.filter.page = 1;
            this._fetchMessages();
            this.props.subscribeRoomMessage(this.props.room._id);
        }
        if (_.get(this.props.roomMessages, `[${this.props.roomMessages.length - 1}]._id`) !== _.get(prevProps.roomMessages, `[${prevProps.roomMessages.length - 1}]._id`)) _.delay(this._scrollToBottom.bind(this), 20);
    }

    componentWillUnmount() {
        this.props.unsubscribeRoomMessage();
    }

    _fetchMessages(more = false) {
        this.props.fetchRoomMessages(this.props.room._id, this.filter, more);
    }

    _scrollToBottom() {
        if (this.messageListRef.current) {
            const scrollHeight = this.messageListRef.current.scrollHeight;
            const height = this.messageListRef.current.clientHeight;
            const maxScrollTop = scrollHeight - height;
            this.messageListRef.current.scrollTop = maxScrollTop;
        }
    }

    _handleMoreMessages() {
        this.filter.page = this.filter.page + 1;
        this._fetchMessages(true);
    }

    _handleDeleteMessage() {
        this.props.deleteRoomMessage(this.props.room._id, this.state.deleteMessageId);
        this.setState({
            toggleDeleteAlert: false,
            deleteMessageId: null
        });
    }

    _handleDeleteMessageAlert(messageId) {
        this.setState({
            toggleDeleteAlert: true,
            deleteMessageId: messageId
        });
    }

    _closeDeleteMessageAlert() {
        this.setState({
            toggleDeleteAlert: false,
            deleteMessageId: null
        });
    }

    _handleToogleUpload(isToogleUpload){
        this.setState({isToogleUpload}, ()=>{
            this._scrollToBottom();
        });
    }

    render() {
        return (
            <Fragment>
                <div className={`messenger-chat ${this.state.isToogleUpload ? "pb-upload" : ""}`}>
                    <div className="messages-list">
                        <div className="in-messages-list" ref={this.messageListRef}>
                            {(!this.props.roomMessagesInitialized || this.props.roomMessagesLoading) &&
                            <SpinLoader className="small"/>}
                            {(this.props.roomMessagesInitialized
                                && !this.props.roomMessagesLoading
                                && this.props.roomMessagesTotal === 0) &&
                            <div className="no-message-in-conversation">Aucun message dans cette
                                conversation. <br/> Lancez-vous ! 😀</div>}
                            {(this.props.roomMessagesMore && !this.props.roomMessagesLoading) && (
                                <div className="button-more-wrapper">
                                    <Button size="small"
                                            onClick={this._handleMoreMessages.bind(this)}
                                            content="Afficher vos anciens messages"/>
                                </div>
                            )}
                            {this.props.roomMessages.map((message, index) => (message.isMessage === false) ? (
                                <div className="date-separator" key={message.createdAt || index}>
                                    {moment().endOf('day').diff(message.date, 'days') === 0 ? "Aujourd'hui" : moment(message.date).format('dddd DD MMMM YYYY')}
                                </div>
                            ) : (
                                <RoomMessage
                                    key={message._id}
                                    message={message}
                                    isGroup={this.props.room.isGroup}
                                    handleOpenMedia={this.props.handleOpenMedia}
                                    handleDelete={this._handleDeleteMessageAlert.bind(this)}
                                    currentUserId={this.props.currentUser._id}
                                    roomOwnerId={this.props.room.owner._id}
                                    isRoomLock={this.props.room.isLocked}
                                    shortPeriod={message.shortPeriod}
                                    beforeMessage={this.props.roomMessages[index - 1]}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                {this.props.room.isLocked ? (
                    <div className="conversation-locked">
                        Vous ne pouvez plus répondre à cette conversation.
                    </div>
                ) : (
                    <RoomSendMessage isCreate={false} currentRoom={this.props.room} handleToogleUpload={this._handleToogleUpload.bind(this)}/>
                )}
                <Modal toggle={this.state.toggleDeleteAlert}
                       handleClose={this._closeDeleteMessageAlert.bind(this)}>
                    <Alert text="Voulez-vous vraiment supprimer ce message ?"
                           handleDelete={this._handleDeleteMessage.bind(this)}
                           handleClose={this._closeDeleteMessageAlert.bind(this)}/>
                </Modal>
            </Fragment>
        )
    }
}

const mapStateToProps = (state, props) => {
    let roomMessages = roomMessagesByRoomId(state, props.room._id);
    return {
        roomMessages: hydrates(roomMessages.data),
        roomMessagesLoading: roomMessages.loading,
        roomMessagesInitialized: roomMessages.initialized,
        roomMessagesTotal: roomMessages.total,
        roomMessagesMore: roomMessages.more
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    subscribeRoomMessage,
    unsubscribeRoomMessage,
    fetchRoomMessages,
    resetRoomMessages,
    deleteRoomMessage,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RoomChat);